import React from 'react'
import {Link} from 'react-router-dom'
import {formatTime, pluralise} from 'admin/lib/format'
import {Status} from 'admin/components/TextMessage'
import ModalLink from '../shared/ModalLink'

export default ({data, organisationID}) => (
  <table className='table is-striped is-fullwidth'>
    <colgroup>
      <col span='1' width='40%' />
      <col span='1' width='20%' />
      <col span='1' width='10%' />
      <col span='1' width='15%' />
      <col span='1' width='15%' />
    </colgroup>
    <thead>
      <tr>
        <th>Message</th>
        <th>Recipients</th>
        <th>Status</th>
        <th>Sender</th>
        <th>Submitted on</th>
      </tr>
    </thead>
    <tbody>
      {data.map((message, i) => {
        const deliveredCount = message.recipients.filter(r => r.status === 'delivered').length

        if (message.recipients.length === 1) {
          const recipient = message.recipients[0]
          return (
            <tr key={i}>
              <td className='has-linebreaks is-size-7' style={{marginBottom: '0', overflowWrap: 'break-word'}}>
                {recipient.content}
              </td>
              <td>
                <Link to={`/orgs/${organisationID}/accounts/${recipient.account.id}`}>
                  {recipient.account.displayName}
                </Link>
                {recipient.account.displayName !== recipient.account.contactFullName &&
                !!recipient.account.contactFullName ? (
                  <sub className='has-text-weight-semibold'>{recipient.account.contactFullName}</sub>
                ) : (
                  <br />
                )}
                {recipient.e164MobileNumber}
              </td>
              <td>
                <Status status={recipient.status} />
              </td>
              <td>{message.sender}</td>
              <td>{formatTime(message.createdAt)}</td>
            </tr>
          )
        } else {
          return (
            <tr key={i}>
              <td className='has-linebreaks is-size-7' style={{marginBottom: '0', overflowWrap: 'break-word'}}>
                {message.contentWithPlaceholders}
              </td>
              <td>
                <ModalLink modal='text-message' params={{textMessageId: message.id}}>
                  {pluralise('recipient', message.recipients.length, true)}
                </ModalLink>
              </td>
              <td>
                <span className='is-size-7'>
                  {`${Math.round((deliveredCount / message.recipients.length) * 100)}% `}
                  delivered
                </span>
              </td>
              <td>{message.sender}</td>
              <td>{formatTime(message.createdAt)}</td>
            </tr>
          )
        }
      })}
    </tbody>
  </table>
)
